// File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/RegisterPage.js

import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AuthPages.css';

export default function RegisterPage() {
  const { register, isAuthenticated, isLoading } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // If already authenticated, redirect to app
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Passwort muss mindestens 8 Zeichen lang sein';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Passwort muss mindestens einen Großbuchstaben enthalten';
    }
    if (!/[a-z]/.test(password)) {
      return 'Passwort muss mindestens einen Kleinbuchstaben enthalten';
    }
    if (!/[0-9]/.test(password)) {
      return 'Passwort muss mindestens eine Zahl enthalten';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    // Validate password strength
    const passwordError = validatePassword(formData.password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    setLoading(true);

    try {
      await register({
        email: formData.email,
        password: formData.password,
        full_name: formData.fullName || undefined,
      });
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-status-card__icon" role="img" aria-hidden="true">📧</span>
            <h2 className="auth-status-card__title">E-Mail bestätigen</h2>
            <p className="auth-status-card__message">
              Wir haben dir eine E-Mail an <strong>{formData.email}</strong> gesendet.
              Bitte klicke auf den Link in der E-Mail, um dein Konto zu aktivieren.
            </p>
            <Link to="/login" className="auth-action-btn">
              Zur Anmeldung
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__header">
          <div className="auth-card__logo">
            <span className="auth-card__logo-icon" role="img" aria-label="Karteikasten">🗃️</span>
            Vokabelkasten
          </div>
          <h2 className="auth-card__title">Konto erstellen</h2>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error" role="alert">
              {error}
            </div>
          )}

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="register-name">
              Name (optional)
            </label>
            <input
              id="register-name"
              className="auth-field__input"
              type="text"
              value={formData.fullName}
              onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
              placeholder="Max Mustermann"
              autoComplete="name"
            />
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="register-email">
              E-Mail *
            </label>
            <input
              id="register-email"
              className="auth-field__input"
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="deine@email.de"
              autoComplete="email"
            />
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="register-password">
              Passwort *
            </label>
            <input
              id="register-password"
              className="auth-field__input"
              type="password"
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="••••••••"
              autoComplete="new-password"
            />
            <span className="auth-field__hint">
              Mind. 8 Zeichen, Groß- und Kleinbuchstaben, eine Zahl
            </span>
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="register-confirm">
              Passwort bestätigen *
            </label>
            <input
              id="register-confirm"
              className="auth-field__input"
              type="password"
              required
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </div>

          <button
            className="auth-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-submit-btn__spinner" />
                Wird registriert…
              </>
            ) : (
              'Registrieren'
            )}
          </button>
        </form>

        <p className="auth-footer">
          Bereits ein Konto?{' '}
          <Link to="/login">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}